import { createResource, type RouteResource } from 'react-resource-router';

import type { RolesResponse } from '../../common/types';
import { getRolesEndpoint } from '../assign-custom-roles/endpoints';

export const rolesResource: RouteResource<RolesResponse> = createResource({
	type: 'rolesResource',
	getKey: () => 'rolesResource',
	getData: getRolesEndpoint,
	isBrowserOnly: true,
});

export const resources = (): RouteResource<RolesResponse>[] => [rolesResource];
